module.exports = __webpack_public_path__ + "static/media/calendar.013d28bb.svg";